"use client";
import { List, ListIcon, ListItem, Text } from "@chakra-ui/react";
import { MdOutlineDoneAll } from "@onemind-services-llc/react-icons-ng/md";
import Img1 from "public/iaas/costEfficient.4c199bb4.svg";
import Img2 from "public/iaas/wordpress-service.2952b864.svg";
import Img3 from "public/iaas/containerizedHosting.0e1aa36b.svg";
import { useTextVariants } from "@/theme/components/useSectionHeading";

type DescriptionProps = {
  points: { label: string; text: string }[];
};

const Content = (props: DescriptionProps) => {
  const { points } = props;
  const textVariant = useTextVariants();
  return (
    <List spacing={2}>
      {points.map((point, i) => (
        <ListItem color={"text.100"} key={i}>
          <ListIcon as={MdOutlineDoneAll} />
          <Text variant={textVariant} as="span" fontWeight={600}>
            {point.label} -{" "}
          </Text>
          <Text variant={textVariant} as="span">
            {point.text}
          </Text>
        </ListItem>
      ))}
    </List>
  );
};
export const SOLUTIONS_CONSTANTS = {
  title: "Onemind’s IaaS Solutions – How We Help You",
  desc: "At Onemind, we provide high-performance, secure, and scalable IaaS solutions, allowing businesses to deploy and manage infrastructure without operational complexity.",
  list: [
    {
      image: Img1,
      title: "Compute & Storage Services",
      content: (
        <Content
          points={[
            {
              text: "Dedicated hardware for high-performance applications.",
              label: "Bare-Metal Servers",
            },
            {
              text: "Scalable and cost-effective cloud-based instances.",
              label: "Virtual Machines (VMs)",
            },
            {
              text: "Secure, scalable, and high-speed storage solutions.",
              label: "Block Storage & Object Storage (S3)",
            },
          ]}
        />
      ),
    },
    {
      image: Img2,
      title: "Network & Security Services",
      content: (
        <Content
          points={[
            {
              text: "Automate & optimize network performance.",
              label: "Software-Defined Networking (SDN)",
            },
            {
              text: "Ensure traffic distribution and secure remote access.",
              label: "Load Balancers & VPNs",
            },
            {
              text: "Advanced security measures for data protection.",
              label: "Firewalls & DDoS Protection",
            },
          ]}
        />
      ),
    },
    {
      image: Img3,
      title: "Disaster Recovery & Business Continuity",
      content: (
        <Content
          points={[
            {
              text: "Reduce downtime and scale dynamically.",
              label: "High Availability & Auto-Scaling",
            },
            {
              text: "Minimize data loss with automatic failover.",
              label: "Backup & Replication",
            },
            {
              text: "Seamlessly connect on-prem and cloud infrastructure.",
              label: "Hybrid Cloud Support",
            },
          ]}
        />
      ),
    },
  ],
};
